module.exports = __webpack_public_path__ + "rosacea_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_1_before.jpg
// module id = 978
// module chunks = 0